import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Ufs from '../../../constants/uf.constant';
import { SignUpModel } from '../../../models/sing-up.model';
import { SignUpService } from '../../../services/sign-up/sign-up.service';



@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.page.html',
    styleUrls: ['./sign-up.page.scss'],
    standalone: false
})
export class SignUpPage implements OnInit {

    public formCadastro?: FormGroup;
    public strUFs: string[] = Ufs;

    constructor(private router: Router,
        private signUpService: SignUpService,
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit() {

        this.formCadastro = this.formBuilder.group({
            name: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            phone: ['', [Validators.required]],
            crm: ['', [Validators.required]],
            uf: ['', [Validators.required]],
            type: ['Médico', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            acceptTerms: [false, [Validators.requiredTrue]],
            acceptTerms2: [false, [Validators.requiredTrue]],
            signature: ['', [Validators.required]]
        });

    }

    setSignature(signature: string) {
        this.formCadastro?.get('signature')?.setValue(signature);
    }

    async touchSignUp() {
        const signUp: SignUpModel = {
            nome: this.formCadastro?.value.name,
            sobrenome: this.formCadastro?.value.lastName,
            telefone: this.formCadastro?.value.phone,
            crm: this.formCadastro?.value.crm,
            uf: this.formCadastro?.value.uf,
            tipo: this.formCadastro?.value.type,
            email: this.formCadastro?.value.email,
            assinatura: this.formCadastro?.value.signature
        };

        // await this.messageService.startLoading();
        await this.signUpService.signUp(signUp).then(async (res: any) => {
            // await this.messageService.stopLoading();

            if (res.status === 200) {
                this.router.navigate(['/login']);
            } else {
                await this.showError(res.message || 'Houve um problema ao lhe cadastrar, tente novamente. <br><br> Caso o problema persista, entre em contato com o suporte.');
            }
        }).catch(async (err: any) => {
            console.error(err);
            await this.showError(err?.error?.message || 'Houve um problema ao lhe cadastrar, tente novamente. <br><br> Caso o problema persista, entre em contato com o suporte.');
        });
    }

    isValidForm() {
        return this.formCadastro?.valid;
    }

    checkIsValidEmail() {
        return this.formCadastro?.value.email.match(
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,6}$/
        );
    }

    async showError(_message: string) {
        /* await this.messageService.showAlertModal({
             imagemUrl: '../../../../assets/icons/warning.svg',
             titleText: 'Erro ao se cadastrar',
             subtitleText: message,
             listButtons: [
                 {
                     textButton: 'Ok',
                     fill: 'outline',
                 }
             ]
         })*/
    }
}
